import Vue from 'vue'
import {make} from 'vuex-pathify'
import {sortByIgnoreCase, kvpsForSelectTheWorks} from 'src/utilities/utils'
import {byId, crudifyMutations, hydrateEdit, savePayload} from 'src/utilities/vuex2'
import {ptracGet, ptracGetEntities} from 'src/utilities/ptracApi'
import {OK} from 'http-status-codes'

let initialState = {
  ui: {
    qbClassFilter: null,
    searchQuery: null,
  },
  results: [],
  edit: {
    id: null,
    name: null,
    qbClass: null,
    description: null,
    active: true,
    departmentId: null,
  },
}

const state = Vue.util.extend({}, initialState)

const getters = make.getters(state)
getters.byId = byId

getters.kvpsForSelect = (state) => {
  return kvpsForSelectTheWorks(state.results, {
    sortBy: 'name',
    labelProp: 'name',
    valueProp: 'id',
    extraValue: 'qbClass'
  })
}
getters.savePayload = savePayload

const mutations = make.mutations(state)
mutations.hydrateEdit = hydrateEdit
crudifyMutations(mutations)

mutations.resetEdit = (state) => {
  state.edit = {
    id: null,
    name: null,
    qbClass: null,
    description: null,
    active: true,
    departmentId: null,
  }
}
mutations.appendToDescription = (state, payload) => {
  if (!state.edit.description) {
    state.edit.description = ''
  }
  if (state.edit.description.length > 0) {
    payload = ' ' + payload
  }
  state.edit.description += payload
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchAll({commit}, includeInactive) {
      let url = 'item-codes/search/findByActiveOrderByNameAsc?&active=true'

      if (includeInactive) {
        url = 'item-codes/search/findAllByOrderByNameAsc'
      }

      const response = await ptracGetEntities(url)

      if (OK === response.status) {
        commit('results', sortByIgnoreCase(response.data, 'name'))
      }

      // if the code above fails in API Gateway - revert
      // try {
      //   // generic axios('get', ...) not working with API Gateway :(
      //   const response = await axios.get(url, Constants.HEADERS.DEFAULT)
      //
      //   commit('results', sortByIgnoreCase(response.data._embedded.itemCodes, 'name'))
      //   return {
      //     result: Constants.RETURN_CODES.SUCCESS
      //   }
      // } catch (e) {
      //   return {
      //     result: Constants.RETURN_CODES.ERROR,
      //     error: e
      //   }
      // }
    },
    async customerExists({}, customerName) {
      return await ptracGet('quickbooks/customer-exists?name=' + customerName)
    }
  }
}
